import React from 'react'
import Logo from '../../images/logo.png'
import { FaFacebook,FaInstagram } from 'react-icons/fa';
import { Button, IconButton } from '@material-tailwind/react';
export default function footer() {
  return (
 <>
 <footer className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-wrap md:text-left text-center order-first">
      <div className="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 className="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">
          CATEGORIES
        </h2>
        <nav className="list-none mb-10">
          <li>
            <a className="text-gray-600 hover:text-gray-800">First Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Second Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Third Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Fourth Link</a>
          </li>
        </nav>
      </div>
      <div className="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 className="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">
          CATEGORIES
        </h2>
        <nav className="list-none mb-10">
          <li>
            <a className="text-gray-600 hover:text-gray-800">First Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Second Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Third Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Fourth Link</a>
          </li>
        </nav>
      </div>
      <div className="lg:w-1/4 md:w-1/2 w-full px-4">
        <h2 className="title-font font-medium text-gray-900 tracking-widest text-sm mb-3">
          CATEGORIES
        </h2>
        <nav className="list-none mb-10">
          <li>
            <a className="text-gray-600 hover:text-gray-800">First Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Second Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Third Link</a>
          </li>
          <li>
            <a className="text-gray-600 hover:text-gray-800">Fourth Link</a>
          </li>
        </nav>
      </div>
      <div className="lg:w-1/4 items-center md:w-1/2 w-full px-4 ">
        
        <div className="flex  xl:flex-nowrap md:flex-nowrap lg:flex-wrap flex-wrap justify-center items-end md:justify-start">
        
        <a className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
       <img src={Logo} alt=""  className="object-fit h-24 w-44" srcset="" />
        
      </a>
     
        </div>
       <div className='mt-4 flex justify-center'>
       <span className="flex   sm:mt-0  mr-8 justify-center  sm:justify-start">

<IconButton variant="text" className="rounded-full">
 <FaFacebook size={20} color="#0D8AF1" />
</IconButton>
<IconButton variant="text" className="rounded-full">
  <FaInstagram size={20}  color="#F7085F" />
</IconButton>

</span>

       </div>
      </div>
    </div>
  </div>
  <div className="bg-gray-100">
    <div className="container px-5 py-6 mx-auto flex justify-center items-center sm:flex-row flex-col">
      <a className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
        
        <span className="ml-3 text-xl">Ghazni</span>
      </a>
      <p className="text-sm  text-gray-500 sm:ml-6 sm:mt-0 mt-4">
        © 2023 Ghazni —
        <a
          href=""
          rel="noopener noreferrer"
          className="text-gray-600 ml-1"
          target="_blank"
        >
          @Rizwan
        </a>
      </p>
     
    </div>
  </div>
</footer>

 
 </>
  )
}
